import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { CacheResolverService } from '../../core/cache/cache-resolver.service';
import { menuOption } from '../../core/constants/nav.constant';
import { PropertiesFormattingService } from '../../modules/events/properties-formatting.service';
import { EventsService } from 'src/app/modules/events/events.service';
import { workflowApiUrl } from 'src/app/modules/events/serviceUrl.constant';
import { HoldService } from '../service/hold.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {

  /*********************Properties*********************/
  navigation = [
    {
      permissionFlag: 'events',
      routeTo: '/dashboard',
      id: 'link1',
      iconName: 'event',
      iconKey: 'Events'
    },
    {
      permissionFlag: 'eventSearch',
      routeTo: '/dashboard/event-receiver',
      id: 'link2',
      iconName: 'search',
      iconKey: 'Event Search'
    },
    {
      permissionFlag: 'productSearch',
      routeTo: '/dashboard/product_search',
      id: 'link3',
      iconName: 'search',
      iconKey: 'Product Search'
    },
    {
      permissionFlag: 'customers',
      routeTo: '/dashboard/customers',
      id: 'link4',
      iconName: 'group',
      iconKey: 'Customers'
    },
    {
      permissionFlag: 'reports',
      routeTo: '/dashboard/reports-dashboard',
      id: 'link5',
      iconName: 'list',
      iconKey: 'Reports'
    },
    {
      permissionFlag: 'message',
      routeTo: '/dashboard/messages',
      id: 'link6',
      iconName: 'library_books',
      iconKey: 'Messages'
    },
    {
      permissionFlag: 'users',
      routeTo: '/dashboard/user',
      id: 'link7',
      iconName: 'how_to_reg',
      iconKey: 'Users'
    },
    {
      permissionFlag: 'provisioning',
      routeTo: '',
      id: 'link8',
      iconName: 'fingerprint',
      iconKey: 'Provisioning'
    },
    {
      permissionFlag: '',
      routeTo: '/dashboard/systemAdmin',
      id: 'link9',
      iconName: 'build',
      iconKey: 'System Admin'
    }
  ]

  clickedButton: string = '';

  menuOption = menuOption;
  menuOptionDisplay: any[] = [];
  menuList: any;
  showSubMenu: boolean = false
  Url: any;
  userDetails: any;

  @ViewChild('sidenav') sidenav: MatSidenav;

  reason = '';
  permissions;
  msgCount: number = 0;
  public dcValueSelected;
  public userRoleSelected: boolean;
  messagesFetch = {
    pageNo: 1,
    pageSize: 10,
    sort: []
  }

  close(reason: string) {
    this.reason = reason;
    this.sidenav.close();
  }
  private readonly ngUnsubscribe = new Subject<void>();

  constructor(
    private router: Router,
    private cacheService: CacheResolverService,
    private formattingService: PropertiesFormattingService,
    private eventService: EventsService,
    private holdService: HoldService,
  ) {
  }

  ngOnInit() {
    this.getUserPermission();
    this.menuOptionDisplay = this.menuOption;
    this.menuList = this.menuOptionDisplay.filter(option => !option.config.displayBottom);
    this.userDetails = this.cacheService.get('user-auth');
    //commented code for future implemation
    //  this.getMsgCount();
    this.holdService.dcSelecetd.pipe(takeUntil(this.ngUnsubscribe)).subscribe(dcselected=>{
        this.dcValueSelected = dcselected[0];
        this.getMsgCount();
    });
  }

  // getMsgCount() {
  //   let userId = this.userDetails.detail.iiqUserId; 
  //   this.eventService.getApiRequest('event', eventApiUrl.msgCount, userId).subscribe(response1 => {
  //     this.msgCount=response1.messageCount;
  //    });
  // }

  getMsgCount() {
    this.holdService.isActive().toPromise().then(value=>{
        this.userRoleSelected = value;
        if (this.userRoleSelected) {
          this.eventService.postApiRequest('workflow', workflowApiUrl.getMessages, this.messagesFetch, '?distributionCentre=' + this.dcValueSelected + '&iiqUserId=' + this.userDetails['detail']['iiqUserId']).
            toPromise().then(res=>{
                this.msgCount = res.totalRecords;
            });
        } else {
          this.eventService.postApiRequest('workflow', workflowApiUrl.getMessages, this.messagesFetch, '?iiqUserId=' + this.userDetails['detail']['iiqUserId'])
            .toPromise().then(res=>{
                this.msgCount = res.totalRecords;
            });
        }
    });
  }

  public getUserPermission() {
    this.formattingService.getUserPermissions().then(res => {
      this.permissions = res
      this.cacheService.set('navData', res);
    }
    ).catch((error) => {
      const navData = this.cacheService.get('navData');
      if (navData) {
        this.permissions = navData;
      } else {
        this.router.navigate(['/login']);
      }
    });
  }


  onMainMenuClicked(event: any, currentIndex: any) {
    this.Url = this.menuOptionDisplay[currentIndex].url;
    if (this.menuOptionDisplay[currentIndex].subMenuItems.length == 0) {
      this.router.navigateByUrl(this.Url);
      this.showSubMenu = false;
    }
    else {
      event.stopPropagation();
      this.showSubMenu = true;
    }
  }
  onSubMenuClicked(subMenu: any, currentIndex: any) {
    this.Url = subMenu.url;
    this.router.navigateByUrl(this.Url);
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


}


